import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { UserRole } from '@/@types/auth';
import { ACCESS_DENIED } from '@/constants/route.constant.ts';
import useAuthority from '@/hooks/useAuthority';

type AuthorityGuardProps = PropsWithChildren<{
  userAuthority: UserRole | null;
  authority?: UserRole[];
}>;

const AuthorityGuard = (props: AuthorityGuardProps) => {
  const { userAuthority = null, authority = [], children } = props;

  const roleMatched = useAuthority(userAuthority, authority);

  return <>{roleMatched ? children : <Navigate to={ACCESS_DENIED} />}</>;
};

export default AuthorityGuard;
